import { getDv360LineItemDates } from './helpers'

import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

export const getInitialValues = lineItem => {
  const { startDate, endDate } = getDv360LineItemDates(lineItem)

  return {
    [START_DATE]: new Date(startDate),
    [END_DATE]: new Date(endDate)
  }
}
